export const appStoreLinksStyles = {
  root: "flex shrink-0 items-center gap-[var(--fw-space-gap-sm)]",
  link: [
    "group inline-flex size-[var(--fw-size-control-lg)] shrink-0 items-center justify-center rounded-full",
    "bg-[var(--fw-color-surface-neutral-secondary)] text-[var(--fw-color-content-neutral-primary)] transition-colors",
    "hover:bg-[var(--fw-color-surface-neutral-tertiary)]",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--fw-color-border-focused)]",
  ].join(" "),
  icon: "size-[var(--fw-size-icon-md)]",
  playSeam:
    "stroke-[var(--fw-color-surface-neutral-secondary)] transition-colors group-hover:stroke-[var(--fw-color-surface-neutral-tertiary)]",
};
